module.exports = __webpack_public_path__ + "img/banner.07d647a7.jpg";